<template>
  <div>
    <v-alert color="#D3EAFD" light>
      <v-row>
        <v-col cols="12" md="6">
          <h3 class="title">Verval Data</h3>
          <span>Verifikasi dan Validasi Data Kepala Sekolah (Pra-Pleno)</span>
        </v-col>
        <v-col cols="12" md="6">
          <span class="caption grey--text">Waktu Penyelesaian</span>
          <h3>{{ $localDate((tahap && tahap.wkt_proses) || '') }}</h3>
        </v-col>
      </v-row>
    </v-alert>
    <list-kandidat
      ref="kandidat"
      :m-jenjang-pusat="mJenjang"
      :is-pusat="true"
      :is-edit="false"
      :detail-id="detail.psp_peringkat_id"
      @delete="onDeleteKandidat"
    ></list-kandidat>
  </div>
</template>

<script>
import ListKandidat from '../../components/kandidat/List';
import { mapActions } from 'vuex';
export default {
  name: 'Kandidat',
  components: { ListKandidat },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    mJenjang: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tahap() {
      const tahaps = this.$getDeepObj(this.detail, 'psp_peringkat_tahaps') || [];
      const filtered = tahaps.filter((item) => item.k_tahap_peringkat_psp === 2);
      const idx = filtered.length - 1;
      return (filtered && filtered[idx]) || {};
    },
  },
  methods: {
    ...mapActions('peringkatVerval', ['action']),

    onDeleteKandidat(item) {
      const nama = this.$getDeepObj(item, 'ptk_kasek.nama') || '';
      const id = this.$getDeepObj(item, 'psp_peringkat_kandidat_id') || '';
      const msg = `Apakan anda ingin menghapus kandidat <strong>${nama}</strong>?`;

      this.$confirm(msg, 'Hapus Kandidat', { tipe: 'error' }).then(() => {
        this.action({ id: this.detail.psp_peringkat_id, aksi: `kandidat-delete/${id}` }).then(() => {
          this.$success('Kandidat berhasil di hapus');
          this.$refs.kandidat.onReload();
        });
      });
    },
  },
};
</script>

<style scoped></style>
